import React from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { IFileProcessModel } from "../../../../typings/models/FileProcessModel";

interface GridRowProps {
  data: IFileProcessModel;
}

const FileProcessGridRow: React.FC<GridRowProps> = ({ data }) => {
  let navigate = useNavigate();

  const handleAmendClick = (id: string) => {
    let path = `/isr-inspections`;
    navigate(path, { state: { id: id, mode: "amend" } });
  };

  return (
    <tr>
      <td>{data.fileName}</td>
      <td>
        {data.status === 1 && "Pending"}
        {data.status === 2 && "Processed"}
      </td>
      <td>
        {moment(data.uploadedDate).format("DD/MM/yyyy, hh:mm a").toString()}
      </td>
      <td>{data.success}</td>
      <td>{data.error}</td>
      <td>{data.errorMessage}</td>

      {/* Add other data fields here */}
    </tr>
  );
};

export default FileProcessGridRow;
